<template>
  <svg class="svg-icon" :style="iconStyle" aria-hidden="true">
    <use :href="symbolId" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// 全局 SVG 雪碧图图标组件
// 图标文件统一放在 src/assets/icons 下，name 为文件名（不含 .svg）
// 单色图标（fill/stroke 为 currentColor）可通过 color prop 或父级 CSS color 控制颜色
const props = defineProps<{
  name: string
  color?: string
  size?: number | string
}>()

const symbolId = computed(() => `#icon-${props.name}`)

const iconStyle = computed(() => {
  const style: Record<string, string> = {}
  if (props.color) style.color = props.color
  if (props.size !== undefined) {
    const size = typeof props.size === 'number' ? `${props.size}px` : props.size
    style.width = size
    style.height = size
  }
  return style
})
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  flex-shrink: 0;
}
</style>
